<template>
  <nav class="container-fluid position-fixed shadow-sm navbar-main">

    <div class="flex-between h-100">

      <!-- LOGO -->
      <div class="flex-center h-100 mx-xl-4">
        <img
          :src="farthermn"
          class="img-fluid m-3 imghover"
          style="max-height: 60px;"
        />
      </div>

      <!-- MOBILE OVERLAY -->
      <div
        class="modalmn d-lg-none"
        v-show="showModal"
        @click.self="closeMenu"
      >
        <div class="modal-content">

          <div class="d-flex flex-column text-uppercase text-success text-center description-xs fw-bold">

            <!-- LANGUAGE -->
            <div class="my-2 imghover">
              <select
                class="p-1 ps-2"
                v-model="$i18n.locale"
                @change="closeMenu"
              >
                <option
                  v-for="locale in $i18n.availableLocales"
                  :key="locale"
                  :value="locale"
                >
                  {{ locale }}
                </option>
              </select>
              / {{ $t("message.nav_co") }}
            </div>

            <!-- LINKS -->
            <div class="my-2 imghover">
              <a href="#forLocalGuides" @click="closeMenu">
                {{ $t("message.nav_Forlocalguide") }}
              </a>
            </div>

            <div class="my-2 imghover">
              <a href="#forTraveler" @click="closeMenu">
                {{ $t("message.nav_ForTraveler") }}
              </a>
            </div>

          </div>

        </div>
      </div>

      <!-- RIGHT SIDE -->
      <div class="flex-center h-100 mx-xl-5">

        <!-- 🍔 MOBILE TOGGLE -->
        <div class="menu-toggle d-lg-none" @click="toggleMenu">
          <span :class="{ active: showModal }"></span>
        </div>

        <!-- DESKTOP MENU -->
        <div class="text-center m-xl-4 m-3 d-none d-lg-block imghover">
          <b>
            <select class="p-1 ps-2" v-model="$i18n.locale">
              <option
                v-for="locale in $i18n.availableLocales"
                :key="locale"
                :value="locale"
              >
                {{ locale }}
              </option>
            </select>
            / {{ $t("message.nav_co") }}
          </b>
        </div>

        <div class="text-center m-xl-4 m-3 d-none d-lg-block navhover">
          <b><a href="#forLocalGuides">{{ $t("message.nav_Forlocalguide") }}</a></b>
        </div>

        <div class="text-center m-xl-4 m-3 d-none d-lg-block navhover">
          <b><a href="#forTraveler">{{ $t("message.nav_ForTraveler") }}</a></b>
        </div>

      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, watch } from "vue"

const farthermn = require("ASSETS/images/farthermn")

const showModal = ref(false)

const toggleMenu = () => {
  showModal.value = !showModal.value
}

const closeMenu = () => {
  showModal.value = false
}

/* 🔒 LOCK BODY SCROLL WHEN MENU OPEN */
watch(showModal, (val) => {
  document.body.style.overflow = val ? "hidden" : ""
})
</script>

<style scoped>

/* NAVBAR */
.navbar-main {
  height: 60px;
  background: #ffffff;
  z-index: 999;
}

/* OVERLAY */
.modalmn {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.modal-content {
  margin-top: 60px;
  background: #ffffffe8;
  padding: 15px 25px;
  border-radius: 10px;
}

/* LINKS */
a {
  text-decoration: none;
  color: inherit;
}

/* HOVER EFFECTS */
.imghover:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.navhover:hover {
  transform: scale(1.05);
  border-bottom: 1px solid #133831;
}

/* 🍔 HAMBURGER ICON */
.menu-toggle {
  width: 30px;
  height: 22px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-toggle span,
.menu-toggle span::before,
.menu-toggle span::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background: #133831;
  border-radius: 3px;
  transition: 0.3s ease;
}

.menu-toggle span {
  top: 50%;
  transform: translateY(-50%);
}

.menu-toggle span::before {
  top: -8px;
}

.menu-toggle span::after {
  top: 8px;
}

/* ✖ ANIMATION */
.menu-toggle span.active {
  background: transparent;
}

.menu-toggle span.active::before {
  top: 0;
  transform: rotate(45deg);
}

.menu-toggle span.active::after {
  top: 0;
  transform: rotate(-45deg);
}

</style>
